import { LOAD_LOCALIZATIONS } from "../actions/actionTypes";

const initialState = {
    localizations: [],
};

export const localizationReducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_LOCALIZATIONS:
            return {
                ...state,
                localizations: action.localizations
            };
        default:
            return state;
    }
};